export const createPathDesinationHTML = (targetPath, media, dimensions) => {
  const container = document.createElement('div');
  container.id = 'path-mesh-popup';
  container.className = 'path-mesh-popup-wrapper';
  container.style.width = `${dimensions.width}px`;
  container.style.height = `${dimensions.height}px`;

  const header = document.createElement('div');
  header.className = 'path-mesh-popup-header';
  header.innerHTML = targetPath.title;

  let imageContainer = null;
  if (media) {
    imageContainer = document.createElement('img');
    imageContainer.className = 'path-mesh-popup-image';
    container.prepend(imageContainer);
  }

  container.appendChild(header);
  document.body.appendChild(container);
  return { html: container, imageContainer };
};
